<template>
  <el-card shadow="never">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Create Rule</span>
      <el-button
        style="float: right;
        padding: 3px 0"
        type="text"
        @click="$emit('save', ruleForm)"
      >
        Save
      </el-button>
    </div>
    <el-form
      :model="ruleForm"
      label-position="left"
      label-width="120px"
      size="medium"
    >
      <el-form-item label="Name">
        <el-input v-model="ruleForm.desc" />
      </el-form-item>
      <el-form-item label="Type">
        <el-select
          v-model="ruleForm.on"
          placeholder="Select Type"
        >
          <el-option
            label="Item"
            value="item"
          />
          <el-option
            label="Consignment"
            value="con"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Rule">
        <el-input
          v-model="ruleForm.expression"
        />
      </el-form-item>
      <el-form-item
        label="AI Builder"
      >
        <el-input
          v-model="prompt"
          type="textarea"
          placeholder="Enter prompt to generate rule expression"
        />
        <el-button
          :loading="isGenerating"
          @click="generateAIRuleFromPrompt(prompt)"
        >
          Generate Rule Expression
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  name: 'RuleForm',
  data () {
    return {
      ruleForm: {
        desc: '',
        on: '',
        expression: ''
      },
      isGenerating: false,
      prompt: ''
    }
  },
  methods: {
    async generateAIRuleFromPrompt (prompt) {
      this.isGenerating = true

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'ratesurchargerule/airesult',
        body: {
          prompt: this.prompt
        }
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.ruleForm.expression = await response.text()
      }

      this.isGenerating = false
    }
  }
}
</script>
<style scoped>

</style>
